export enum EventAppearanceType {
  All = 'All',
  NonRecurring = 'NonRecurring',
  Recurring = 'Recurring',
}

export type LiveEventInstanceTableFilters = {
  eventAppearance?: EventAppearanceType
}
